import { h } from 'preact';
import Section from 'components/bolt/section/section';
import { joinClasses, accessNested } from 'utils/utils';
import { navigateInternally } from 'utils/bolt';
import HTML from 'components/core/html/html';
import Gallery from 'components/bolt/gallery/gallery';
import { smoothScrollTo } from 'utils/smoothScroll';
import s from 'components/bolt/text/text.sss';
import { marked } from 'marked';
import Store from 'store/store';

marked.setOptions({
	breaks: true,
	smartLists: true
});

export default class Text extends Section {
	constructor(props) {
		super(props);

		this.scrollOnHashChange = this.scrollOnHashChange.bind(this);
		this.updateHash = this.updateHash.bind(this);
		this.scrollToGallery = this.scrollToGallery.bind(this);
		this.updateHashAndScrollToGallery = this.updateHashAndScrollToGallery.bind(this);
		this.getPageWidth = this.getPageWidth.bind(this);
		this.onClick = this.onClick.bind(this);
		this.renderText = this.renderText.bind(this);
		this.renderGallery = this.renderGallery.bind(this);

		let text = props.appData?.pages?.[props.id]?.data?.text;
		this.text = props.appData?.copy?.baseCopy?.[text] || text || '';
	}

	componentDidMount() {
		window.addEventListener('hashchange', this.scrollOnHashChange);
		const elems = document.querySelectorAll('.galleryContentLink');
		if (elems) {
			elems.forEach(item => {
				if (!item.id) return;
				item.addEventListener('click', () => this.updateHashAndScrollToGallery('#' + item.id));
			});
		}
		this.scrollOnHashChange();
	}

	componentWillUnmount() {
		window.removeEventListener('hashchange', this.scrollOnHashChange);
	}

	scrollOnHashChange() {
		const hash = typeof window !== 'undefined' && location.hash.slice(1);
		if (!hash) return;
		this.scrollToGallery();
	}

	updateHash(hash) {
		if (!hash) return;
		window.location.hash = hash;
	}

	scrollToGallery() {
		const offset = this.props.client.headerHeight || 60;
		const mainScroll = document.getElementById('mainScroll');
		const targetElem = document.getElementById(`${this.props.id}GalleryImageWrapper`);
		if (targetElem) {
			smoothScrollTo(mainScroll, targetElem, 500, { offset });
		}
	}

	updateHashAndScrollToGallery(hash) {
		this.updateHash(hash);
		this.scrollToGallery();
	}

	getPageWidth(currentPage, section) {
		const store = Store.get();
		const deviceSize = accessNested(store, 'client.deviceSize', '');
		const size = currentPage?.data?.size;

		if (!section || !size) {
			return;
		}

		let width = size.mobile || '100%';

		if (deviceSize === 'largeDesktop') {
			width = size.largeDesktop || '100%';
		} else if (deviceSize === 'desktop') {
			width = size.desktop || '100%';
		} else if (deviceSize === 'smallDesktop') {
			width = size.smallDesktop || '100%';
		} else if (deviceSize === 'tablet') {
			width = size.tablet || '100%';
		}

		if (width.trim().endsWith('px') || width.trim().endsWith('%')) {
			return width;
		}

		return width.replace(/\D/g, '') + 'px';
	}

	onClick(e) {
		let internalLink = e.target.closest('a[href^="#$"]');
		if (internalLink) {
			e.preventDefault();
			let page = internalLink.getAttribute('href').slice(2).trim();
			let navOptions = {};
			if (page.includes('/?')) {
				let [pageId, qs] = page.split('/?');
				page = pageId;
				navOptions.queryString = '?' + qs;
			}
			navigateInternally(page, navOptions);
		}
	}

	renderText() {
		return <HTML class={s.content} onClickCapture={this.onClick} content={this.text} markdown />;
	}

	renderGallery() {
		const appData = accessNested(this.props.store, 'appData', {});
		const client = accessNested(this.props.store, 'client', {});
		return <Gallery appData={appData} client={client} id={this.props.id} isEmbeded />;
	}

	render({ store, id }) {
		const currentPage = accessNested(store, `appData.pages.${id}`, {});
		const section = accessNested(store, `appData.pages.${id}.section`,);
		const headerHeight = accessNested(store, `client.headerHeight`, '');
		const isDesktopWidth = accessNested(store, 'client.isDesktopWidth');
		const hasGallery = accessNested(store, `appData.pages.${id}.data.gallery`, '');
		const needsPushDown = !isDesktopWidth && !section;
		const width = this.getPageWidth(currentPage, section);
		const text = this.renderText();

		return (
			<div class={joinClasses(s.container, id, !section && s.dedicatedPage)} data-section={id}>
				<div style={{ width, marginTop: needsPushDown ? `${headerHeight}px` : '0px' }} class={joinClasses(s.wrapper, currentPage.data.bg && s.noBg)}>
					{this.renderBgContent()}
					{text}
					{this.renderOverlayedContent()}
				</div>
				{hasGallery && this.renderGallery()}
			</div>
		);
	}
}
